var normalizeComponent = require("!../../vue-loader/lib/component-normalizer")
/* script */
var __vue_script__ = null
/* template */
var __vue_template__ = require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-23db0a48\",\"hasScoped\":false,\"buble\":{\"transforms\":{}}}!../../vue-loader/lib/selector?type=template&index=0!./loader.vue")
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-feather-icon/components/loader.vue
// module id = /94s
// module chunks = 0